import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

export default function MeetingList() {
  const navigate = useNavigate();
  const [meetingList, setMeetingList] = useState();

  useEffect(() => {
    getMeetingList();
  }, []);

  const write = () => {
    navigate('/client/meeting/write');
  };

  const detail = item => {
    const encodedArray = JSON.stringify(item);

    localStorage.setItem('detail', encodedArray);

    navigate('/client/meeting/detail');
  };

  const getMeetingList = () => {
    Server.sendGet('client/meet', {}, getMeetingListCallback).then();
  };

  const getMeetingListCallback = res => {
    setMeetingList(res['resultList']);
  };

  return (
    <MeetWrap>
      <div className='content-inner'>
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Minute Of Meeting</h4>
          </div>
        </div>
        <div className='util-area'>
          <button
            className='write-btn'
            onClick={() => write()}
          >Write
          </button>
        </div>

        <div className='content'>
          <table>
            <colgroup>
              <col width='10%'/>
              <col width='10%'/>
              <col width='40%'/>
              <col width='15%'/>
              <col width='15%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>No</th>
              <th>Client</th>
              <th>Title</th>
              <th>Update Date</th>
              <th>Last Modify</th>
              <th>Detail</th>
            </tr>
            </thead>
            <tbody>
            {meetingList?.map((item, idx) => (
              <>
                <tr>
                  <td>{idx + 1}</td>
                  <td>{item.custName}</td>
                  <td>{item.title}</td>
                  <td>{item.updateDate}</td>
                  <td>{item.updateId}</td>
                  <td>
                    <button
                      className='read'
                      onClick={() => detail(item)}
                    >Detail</button>
                  </td>
                </tr>
              </>
            ))}
            {Common.isEmpty(meetingList) &&
              <tr>
                <td colSpan={5} className={'none-data'}>
                  There is no data.
                </td>
              </tr>
            }
            </tbody>
          </table>
        </div>
      </div>
    </MeetWrap>
  )
}

const MeetWrap = styled.div`
  position: relative;
  flex: 1;

  .util-area {
    position: relative;
    margin-top: 35px;
    padding: 15px 20px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 0 15px;
    width: 100%;

    button {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      background: #a4a4a4;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;

      &:hover {
        background-color: #7e7e7e;
      }
    }
  }

  table {
    position: relative;
    border-top: 1px solid #000000;
    border-bottom: 1px solid #000000;

    th {
      padding: 10px 0;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      background: #f7f7f7;
      border-bottom: 1px solid #000000;
    }

    td {
      padding: 10px 0;
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      text-align: center;
      vertical-align: middle;

      &.left {
        text-align: left;
      }

      button {
        display: inline-block;
        padding: 0 20px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        background: #0072B9;
        border-radius: 8px;
      }
    }
  }
`;